import { FlyOut } from '@/Client/Widgets';
import { ApiOrgProduct } from '@kaiizen/kai-pro-api';
import { FocusedOrgProductDetails } from './FocusedOrgProductDetails';

export const FocusedOrgProductFlyout = ({
  orgProduct,
  open,
  onClose,
}: {
  orgProduct: ApiOrgProduct | null;
  open: boolean;
  onClose: () => void;
}) => {
  if (!orgProduct) return null;

  return (
    <FlyOut
      open={open}
      flyOutClosed={onClose}
      title='Product Details'
    >
      <FocusedOrgProductDetails orgProduct={orgProduct} />
    </FlyOut>
  );
};
